module.exports = __webpack_public_path__ + "static/img/traning03.e05160bc.png";